

// assigns click handlers to the select image buttons that display in the center of each image area - these buttons are
// separated from selection controls and require positional data to be gathered so that the underlying image area can
// be found when prompting our custom gallery component
import {isDevXd} from "@Common/ui-components/debug/is-dev";

export const addEditorSelectImageButtonHandlers = (ccVersionMajor) => {
    return [
        "if (!window.xdData) window.xdData = {};",
        "$('.cc-icon-select-image').off().click(function(e) {",
        "   window.xdData.LastSelectImageButtonPosition = {",
        "       left: parseInt($(e.target).parent().parent().css('left')) + parseInt($(e.target).parent().parent().css('width')) / 2,",
        "       top: parseInt($(e.target).parent().parent().css('top')) + parseInt($(e.target).parent().parent().css('height')) / 2,",
        `       canvasWidth: $('#${ccVersionMajor == 5 ? "cvContent":"cvWhitespace"}').width(),`, // originally used #Content_CanvasViewer - switched to its first child to account for margin space
        `       canvasHeight: $('#${ccVersionMajor == 5 ? "cvContent":"cvWhitespace"}').height(),`, //image placeholders moved from cvContent to cvWhitespace with margin space on v6.
        "   };",
        isDevXd() && "console.log('FROM IFRAME: Clicked blue icon', window.xdData);",
        "});",
    ].filter(v=>v).join("");

};
